import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

interface NavbarProps {
  city: string;
}

export function Navbar({ city }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-teal rounded-xl flex items-center justify-center">
              <i className="ri-window-line text-white text-2xl"></i>
            </div>
            <div>
              <div className="font-bold text-xl text-gray-900">FenetrePro</div>
              <div className="text-xs text-teal font-medium">{city}</div>
            </div>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal' : 'text-white hover:text-teal'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('baies-vitrees')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal' : 'text-white hover:text-teal'
              }`}
            >
              Baies Vitrées
            </button>
            <button
              onClick={() => scrollToSection('diagnostic')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal' : 'text-white hover:text-teal'
              }`}
            >
              Diagnostic
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-orange hover:bg-orange-dark text-white px-6 py-3 rounded-xl font-medium transition-all hover:-translate-y-1 hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Devis Gratuit
            </button>
          </div>
        </div>
      </div>
    </motion.nav>
  );
}